import { BaseButton, Sidebar } from "@velocity-ehs/component-library";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MakePersonUserForm } from "./MakePersonUserForm";
import UsersService from "@velocity-ehs/user-utils-module";
import usePersonMutation, {
  PersonActions,
} from "../../../hooks/usePersonMutation";

interface Props {
  showSlider: boolean;
  closeSliderCallback: () => void;
  refetchCallback: () => void;
  person: {
    id: string;
    email?: string;
    firstName?: string;
    lastName?: string;
  };
}

export interface IMakePersonUserForm {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
}

const MakePersonUserSlider: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const { mutations } = usePersonMutation();

  const formMethods = useForm<IMakePersonUserForm>({
    mode: "onBlur",
    defaultValues: {
      email: props.person.email,
      username: "",
      firstName: props.person.firstName,
      lastName: props.person.lastName,
    },
    shouldUnregister: true,
  });

  useEffect(() => {
    if (props.person) {
      formMethods.reset({
        email: props.person.email,
        firstName: props.person.firstName,
        lastName: props.person.lastName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.person]);

  const handleCreateUserFromPerson = (values: IMakePersonUserForm) => {
    const customerId = UsersService.customer.id;
    const personId = props.person.id;

    const body = {
      ...values,
      customerId,
      id: personId,
    };

    return mutations
      .mutate(PersonActions.CREATE_USER_FROM_PERSON, body)
      .then(() => {
        props.refetchCallback();
        props.closeSliderCallback();
      });
  };

  const footerButtons = () => {
    return (
      <>
        <BaseButton
          type="submit"
          form="makePersonUserForm"
          loading={mutations.isLoading}
          label={t("universal_Save")}
        />
        <BaseButton
          type="button"
          label={t("universal_Cancel")}
          className="p-button-text"
          onClick={props.closeSliderCallback}
        />
      </>
    );
  };

  return (
    <Sidebar
      header={t("make_person_user_slider_title")}
      visible={props.showSlider}
      onHide={props.closeSliderCallback}
      footer={footerButtons()}
    >
      <MakePersonUserForm
        formMethods={formMethods}
        createUserFromPersonCallback={handleCreateUserFromPerson}
      />
    </Sidebar>
  );
};

export { MakePersonUserSlider };
